import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { BaseStateComponent } from '@layout/base-state.component';
import { BackendAdminDeleteUsersComponent } from './backend-admin-delete-users.component';
import { NgModule } from '@angular/core';

const BACKEND_ADMIN_DELETE_USERS_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.backend_admin.admin.users-delete',
        url: '/users-delete',
        abstract: true,
        component: BaseStateComponent,
    },
    {
        name: 'base.backend_admin.admin.users-delete.index',
        url: '',
        views: {
            '^.^.^.^.$default': {
                component: BackendAdminDeleteUsersComponent,
            },
        },
    },
];


@NgModule({
    imports: [UIRouterModule.forChild({ states: BACKEND_ADMIN_DELETE_USERS_STATES })],
})
export class BackendAdminDeleteUsersStateModule {}
